<template>
  
    <div class="container">        
        <div class="row pt-5 pb-5">
            <div class="login-window d-flex">
                <div class="slider reasonbg p-3">

                  <h2 class="text-center pb-3"><span>{{$t('5 reasons')}}</span> {{$t('to buy from us')}}</h2>
                  <ul class="row">
                      <li class="col-md-6 text-center">
                        <i class="reason-icon reason-1"></i>
                        <p>{{ $t('We are 100 % Finnish company, we employ people in Finland, we pay taxes in Finland.') }}</p>
                    </li>
                    <li class="col-md-6 text-center">
                        <i class="reason-icon reason-4"></i>
                        <p>{{ $t('We have large amount of service partners which cover all Finland, over 1000 free fitting times daily.') }}</p>
                    </li>
                    <li class="col-md-6 text-center">
                        <i class="reason-icon reason-2"></i>
                        <p>{{ $t('Low prices, own big stock and wide range of tyres, part payment, many different payment methods.') }}</p>
                    </li>
                    <li class="col-md-6 text-center">
                        <i class="reason-icon reason-3"></i>
                        <p>{{ $t('Fast delivery 24h, good service, Chat open.') }}</p>
                    </li>
                    <li class="col-md-12 text-center">
                        <i class="reason-icon reason-5"></i>
                        <p>{{ $t('Purchasing tyres from Finland you help reduce CO2 emission, we sale Ecological Tyres also.') }}</p>
                    </li>
                  </ul>
                  
                </div>

                <div class="login-form">
                    <h1>{{ $t('Login to Renkaatalle') }} </h1>
                    <div v-if="isShow">
                        <bootstrap-alert 
                            :variant="response.variant" 
                            :msg="response.message" 
                            :errorMsg="response.errmsg" 
                        />
                    </div>
                    
                    <p>{{ $t('Please enter your credentials to login') }}</p>
                    <form class="w-100" @submit.stop.prevent="handleSubmit">
                        
                          <div v-if="loading" class="loading"></div>
                          <p v-if="authenticationError" class="error">
                            <span v-for="(error,key) in authenticationError.errors" v-bind:key="key">
                              {{error}}
                            </span>
                          </p>
                          <flash-message class="error"></flash-message>
                          <div class="form-group">
                                <label for="email">
                                  {{ $t('Email Address') }}
                                  <span class="required">*</span>
                                </label>
                                <input 
                                  type="email" 
                                  class="form-control input-field" 
                                  id="email" 
                                  v-model="email" 
                                  autocomplete="off"
                                  name="email" 
                                  :placeholder="$t('Email')" />
                                <span v-if="emailError" class="error">{{ $t('Email is required') }}</span>
                                <span v-if="emailvalid" class="error">{{ $t('Please enter valid email') }}</span>
                          </div>
                          <div class="form-group">
                            <label for="password">
                              {{ $t('Password') }}
                              <span class="required">*</span>
                            </label>
                            <input
                              type="password"
                              id="password"
                              name="password"
                              v-model="password"
                              class="form-control input-field"
                              :placeholder="$t('Password')"
                            />
                            <span v-if="passError" class="error">{{ $t('Password is required') }}</span>
                          </div>
                          <div class="form-group form-check">
                              <div class="row">
                                <!-- <div class="col-6 pl-0">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck1">
                                        <label class="custom-control-label" for="customCheck1">Remember me?</label>
                                    </div> 
                                </div>-->
                                <div class="col-12 text-right">
                                    <router-link
                                      class="color-black"
                                      :to="{ name: 'reset-password-link' }"
                                    >{{ $t("Forgot Password ?") }}</router-link>
                                  
                                </div>
                            </div>

                          </div>
                          <input type="submit" class="btn btn-primary d-block w-100 login-button bg-black mb-4" :value="$t('Login')" />
                    </form>   
                    <p class="d-block pbutton w-100 text-center">{{ $t("Dont’t have an account yet?") }} <router-link class="color-black font-weight-bold" :to="{ name: 'register' }">{{ $t('Register Now!') }}</router-link></p>
                </div>
            </div>
        </div>
    </div>
  
</template>

<script>
import { mapGetters, mapActions } from "vuex";
require('vue-flash-message/dist/vue-flash-message.min.css');

export default {
  name: "login",
  metaInfo: {
    title: 'Login Page',
    meta: [
      { charset: 'utf-8' },
      { name: 'title', content:  'Login Page'},
      { name: 'description', content: 'This is login page'},
      { name: 'keywords', content:  'renkaatalle, Renkaatalle.fi, login'},
      { name: 'robots', content: 'index,follow'}
    ],
    link: [
      {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'login'}
    ]
  },
  data() {
    return {
      email: "",
      password: "",
      emailError: false,
      emailvalid: false,
      passError: false
    };
  },
  components: {
    //ValidationProvider
  },
  computed: {
    ...mapGetters("auth", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode",
      "authenticationSuccess",
      "loading"
    ]),
    ...mapGetters('app', ['currentLang']),
    ...mapGetters('resetpassword', ['response', 'isShow']),
  },
  methods: {
    ...mapActions("auth", ["login"]),
    ...mapActions("cart", ["loginMergeCartProducts", "getAllCartProducts"]),
    ...mapActions('resetpassword', ['setIsShow', 'resetError']),
    handleSubmit() {
      var setflag = 1;
      this.emailError = false;
      this.passError = false;
      this.emailvalid = false;

      if (this.email == "") {
        this.emailError = true;
        setflag = 0;
      } else {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var valid = regex.test(this.email);
        if (!valid) {
          this.emailvalid = true;
          setflag = 0;
        }
      }

      if (this.password == "") {
        this.passError = true;
        setflag = 0;
      }

      if (setflag) {
        let formdata = {
          email: this.email,
          password: this.password,
          lang: this.currentLang
        };
        this.login(formdata)
        .then((x) => {
        }).finally(() => {
            this.klaviyoIdentifyUser(this.email)
            this.loginMergeCartProducts()
            this.getAllCartProducts()
        });
      }
    }
  },
  created() {
    if(this.isShow) {
      var self = this;
      setTimeout(function(){ 

        self.setIsShow(false)
        
      }, 3000);
    }    
  }
};
</script>